import JoditEditor from "jodit-react";
import React, { useMemo, useRef } from "react";
// import "react-quill/dist/quill.snow.css";
// import "../../utils/highlight";
// Assuming this is a custom syntax highlighter or similar utility

export default function Editor({
  id = "minimal-quill",
  error,
  value,
  onChange,
  simple = false,
  helperText,
  sx,
  placeholder = "",
  readonly = false,
  ...other
}) {
  const editor = useRef(null);

  const config = useMemo(
    () => ({
      // preset: "inline",
      enableDragAndDropFileToEditor: true,
      // uploader: {
      //   insertImageAsBase64URI: true,
      //   imagesExtensions: ["jpg", "png", "jpeg", "gif", "avif", "webp"],
      // },
      uploader: {
        url: `${process.env.REACT_APP_HOST_API_KEY}upload-files`,
        format: "json",
        method: "POST",
        prepareData: function (data) {
          return data;
        },
        filesVariableName: function (i) {
          return "files[" + i + "]";
        },
        isSuccess: function (resp) {
          return !resp.error;
        },
        getMessage: function (resp) {
          return resp.msg;
        },
        process: function (resp) {
          return {
            files: resp.files || [],
            path: resp.path,
            baseurl: resp.baseurl,
            error: resp.error,
            msg: resp.msg,
          };
        },
        defaultHandlerSuccess: function (data, resp) {
          var i,
            field = "files";
          if (data[field] && data[field].length) {
            for (i = 0; i < data[field].length; i += 1) {
              this.s.insertImage(data.baseurl + data[field][i]);
            }
          }
        },
        error: function (e) {
          this.message.message(e, "error", 4000);
        },
      },
      style: {
        a: {
          color: "blue", // Set link color to blue
          textDecoration: "underline", // Optionally underline the link
        },
      },

      // buttons: [
      //   "bold",
      //   "italic",
      //   "underline",
      //   "link",
      //   "image",
      //   "ul", // Bullet list
      //   "ol", // Numbered list
      // ],
      // plugins: ["link", "image"],
      toolbarSticky: true, // Makes the toolbar sticky
      toolbarStickyOffset: 62,
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      toolbarAdaptive: false,
      readonly: readonly,
      placeholder: "",
      // buttons: ["image", "bold"],
    }),
    [readonly]
  );

  return (
    <>
      {/* Add the sticky CSS */}
      <style>
        {`
          .jodit-toolbar {
            position: sticky;
            top: 0;
            z-index: 100;
            background: white;
          }
        `}
      </style>
      <JoditEditor
        ref={editor}
        value={value}
        config={config}
        onBlur={onChange}
      />

      {/* </StyledEditor> */}
    </>
  );
}
